<template>
	<div>
		<div>
			<a @click="createNewExpense" class="button is-info">Create expense</a>
		</div>
		<div class="vertical_space"></div>
		<div class="vertical_space"></div>
		<div>
			<div v-for="expense in expenses" class="flex flex_align_center expense">
				<p>{{ expense.name }} <span>({{ expense.amount || 'לא הוגדר עמלה' }})</span></p>
				<div class="horizontal_space"></div>
				<a @click="editExpense(expense)" class="button is-info is-outlined">Edit Expense</a>
				<div class="horizontal_space"></div>
				<a @click="deleteExpense(expense)" class="button is-danger is-outlined">Delete</a>
			</div>
			<div v-if="is_loading" class="loading"></div>
			<p dir="ltr" v-if="!is_loading && expenses.length == 0">No expenses in this offer.</p>
		</div>
	</div>
</template>
<script>
	import { mapMutations } from 'vuex'
	export default {
		name: 'offer-expenses-for',
		props: ['payload'],
		data(){
			return {
				is_loading: false,
				expenses: [],
			}
		},
		created(){
			this.init()
		},
		methods: {
			init(){
				this.is_loading = true
				this.$network_utils.getExpenses({ offer_id: this.payload.data.id }).then(response => {
					this.expenses = response
					this.is_loading = false
				})
			},
			createNewExpense(){
				this.createModal({
					component_name: 'ExpenseForm',
					modal_title: 'Create new Expense',
					offer: this.payload.data,
					is_create: true,
					callback: this.init
				})
			},
			editExpense(expense){
				this.createModal({
					component_name: 'ExpenseForm',
					modal_title: expense.name,
					data: expense,
					offer: this.payload.data,
					callback: this.init
				})
			},
			deleteExpense(delete_data){
				this.createModal({
					designator: 'delete-prompt',
					component_name: 'DeletePrompt',
					modal_title: 'Delete ' + delete_data.name,
					item_name: delete_data.name,
					method: 'deleteExpense',
					method_params: { id: delete_data.id },
					refresh: this.init
				})
			},
			...mapMutations('modals', ['createModal'])
		}
	}
</script>
<style scoped>
	.expense {
		margin-bottom: 10px;
	}
</style>